/**
 * 病症标签模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取病症标签列表
export const maladyLabelList = (params) => {
  return req.get('/hosp/pathology/label/list', params);
}

// 新增病症标签
export const maladyLabelAdd = (params) => {
  return req.post('/hosp/pathology/label', params);
}

// 修改病症标签信息
export const maladyLabelEdit = (params) => {
  return req.put('/hosp/pathology/label', params);
}

// 删除病症标签信息
export const maladyLabelDelete = (pathologyLabelIds) => {
  return req.delete(`/hosp/pathology/label/${pathologyLabelIds}`);
}